export function DesignerView(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: "lc-designer lowcode-plugin-designer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lc-project"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lc-simulator-shell"
  }, /*#__PURE__*/React.createElement("iframe", {
    name: "webview-view-" + props.viewName,
    className: "lc-simulator-content-frame",
    style: {
      height: '100%',
      width: '100%'
    },
    src: props.url
  }))));
}
export function getWebviewPlugin(url, viewName) {
  function webviewPlugin(ctx) {
    var skeleton = ctx.skeleton;
    return {
      init: function init() {
        skeleton.add({
          area: 'mainArea',
          name: 'designer',
          type: 'Widget',
          content: DesignerView,
          contentProps: {
            ctx: ctx,
            url: url,
            viewName: viewName
          }
        });
      }
    };
  }
  webviewPlugin.pluginName = '___webview_plugin___';
  return webviewPlugin;
}